module.exports = __webpack_public_path__ + "media/entities/2302-be143279.png";